(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const form = root.closest('form');
    const config = JSON.parse(root.querySelector('[data-rt-card-config]').textContent);
    const product = JSON.parse(root.querySelector('[data-rt-card-variants]')?.textContent
      || root.closest('[data-product]').dataset.product);
    const variantField = form.querySelector('[name="id"]');
    const variants = product.variants.map(variant => ({ ...variant,
      selectedOptions: product.options.map((name, i) => ({ name, value: variant.options[i] })) }));
    let syncing = false;
    function syncVariant(refreshTheme = false) {
      if (syncing) return;
      const selectors = product.options.map((_, i) => form.querySelector('.single-option-selector[data-option="option' + (i + 1) + '"]'));
      // Mobilia creates these after its product initializer runs.
      if (selectors.some(selector => !selector)) return;
      syncing = true;
      try {
        let candidates = variants;
        let changed = false;
        selectors.forEach((selector, i) => {
          const choices = [...new Set(candidates.map(variant => variant.selectedOptions[i].value))];
          const previous = selector.value;
          if (JSON.stringify([...selector.options].map(option => option.value)) !== JSON.stringify(choices)) {
            selector.replaceChildren(...choices.map(value => new Option(value, value)));
            changed = true;
          }
          selector.value = choices.includes(previous) ? previous : choices[0] ?? '';
          changed ||= selector.value !== previous;
          candidates = candidates.filter(variant => variant.selectedOptions[i].name === product.options[i]
            && variant.selectedOptions[i].value === selector.value);
        });
        const variant = candidates.length === 1 ? candidates[0] : null;
        variantField.disabled = !variant;
        variantField.value = variant ? String(variant.id) : '';
        // Reuse Mobilia's price/button/history callback; its cart handler stays intact.
        if (refreshTheme && changed) selectors[0].onchange?.();
        return variant;
      } finally { syncing = false; }
    }
    // Filter dependent options before Mobilia looks up the variant at the target.
    form.addEventListener('change', event => {
      if (event.target.matches('.single-option-selector')) syncVariant();
    }, true);
    const observer = new MutationObserver(() => syncVariant(true));
    observer.observe(form, { childList: true, subtree: true });
    syncVariant(true);
    root.dataset.ready = 'true';
    const fields = document.createElement('div'); fields.className = 'rt-card-fields'; root.append(fields);
    const notice = document.createElement('p'); notice.className = 'rt-card-notice';
    notice.textContent = 'FREE Standard US shipping is included in the price. Wallet cards have 10 days of handling and no Rush or Overnight option; allow about 2–3 weeks after approval. ' +
      (config.prefix === 'FUNERAL' ? 'Need them for a service this week? Choose Rush on the larger Fast delivery (A6) card. Rush and Overnight are paid upgrades already included in the selected variant total. ' : '') +
      'Pay securely at checkout. We will email your proof before printing. Check every name and date, then approve or request changes. Delivery timing starts after approval and final checks. Estimates are not guarantees. US delivery only.';
    root.append(notice);
    const make = (tag, text) => { const e = document.createElement(tag); if (text) e.textContent = text; return e; };
    const select = (choices, required) => {
      const input = make('select'); input.append(new Option('Please choose', ''));
      for (const [value, label] of Object.entries(choices)) input.append(new Option(label, value));
      input.required = required; return input;
    };
    let sacrament;
    if (!config.sections.default) {
      const label = make('label', 'Sacrament');
      sacrament = select({ baptism: 'Baptism', 'first-communion': 'First Communion', confirmation: 'Confirmation' }, true);
      // Visible line-item value matches the server's fixed sacrament map.
      const hidden = make('input'); hidden.type = 'hidden'; hidden.name = 'properties[Sacrament]';
      label.append(sacrament); root.prepend(label, hidden);
      sacrament.addEventListener('change', () => { hidden.value = sacrament.selectedOptions[0].textContent; render(sacrament.value); });
    }
    function render(key) {
      const previous = Object.fromEntries([...fields.querySelectorAll('[name]')].map(e => [e.name, e.value]));
      fields.replaceChildren();
      const section = config.sections[key]; if (!section) return;
      const priority = name => name === 'Art' ? 0 : name === 'Prayer' ? 1 : 2;
      for (const [name, cfg] of Object.entries(section.fields).sort(([a], [b]) => priority(a) - priority(b))) {
        if (name === 'Front name band' || cfg.type === 'band_select') continue;
        const text = name === 'Pronoun' ? 'Who does this prayer refer to? *' : cfg.label + (cfg.required ? ' *' : /optional/i.test(cfg.label) ? '' : ' (optional)');
        const label = make('label', text);
        let input;
        if (name === 'Art') input = select(section.art, true);
        else if (name === 'Prayer') input = select(Object.fromEntries(Object.entries(config.prayers).map(([k,v]) => [k,v.title])), true);
        else if (name === 'Pronoun') input = select({ he: 'He', she: 'She' }, false);
        else if (cfg.type === 'vow_select') input = select({ 'First Vows': 'First Vows', 'Final Vows': 'Final Vows' }, true);
        else { input = make('input'); input.type = cfg.type === 'date' ? 'date' : cfg.type === 'photo' ? 'file' : 'text'; input.required = Boolean(cfg.required); }
        const identifier = 'rt-card-' + config.id + '-' + key + '-' + name.replace(/\W/g, '-');
        input.id = identifier; label.htmlFor = identifier;
        if (cfg.max_length) input.maxLength = cfg.max_length;
        input.name = 'properties[' + name + ']';
        if (name !== 'Art' && previous[input.name] && input.type !== 'file') input.value = previous[input.name];
        if (input.type === 'file') {
          input.removeAttribute('name'); input.accept = 'image/jpeg,image/png,image/webp';
          const hidden = make('input'); hidden.type = 'hidden'; hidden.name = 'properties[Photo]'; label.append(hidden);
          let generation = 0;
          input.addEventListener('change', async () => {
            const current = ++generation; hidden.value = ''; input.setCustomValidity('');
            if (!input.files[0]) return;
            const file = input.files[0];
            if (file.size > 10_000_000 || !['image/jpeg','image/png','image/webp'].includes(file.type)) { input.setCustomValidity('Choose a JPG, PNG or WebP photo under 10 MB.'); input.reportValidity(); return; }
            input.setCustomValidity('Please wait for your photo to finish uploading.');
            try {
              const image_data_url = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsDataURL(file); });
              const response = await fetch('https://my.restoredtraditions.com/design/api/upload-photo', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ image_data_url }) });
              const data = await response.json();
              if (!response.ok || !data.ok || !/^https:\/\/my\.restoredtraditions\.com\/print-files\/personalized\/uploads\/[a-f0-9]+\/photo\.(jpeg|png|webp)$/.test(data.url)) throw new Error('Upload failed');
              if (generation === current) { hidden.value = data.url; input.setCustomValidity(''); }
            } catch { if (generation === current) { input.setCustomValidity('The photo could not upload. Please try again or remove it.'); input.reportValidity(); } }
          });
        }
        label.append(input); fields.append(label);
      }
      const prayer = fields.querySelector('[name="properties[Prayer]"]');
      const pronoun = fields.querySelector('[name="properties[Pronoun]"]');
      const prayerText = make('p'); prayerText.className = 'rt-prayer-text'; prayerText.setAttribute('aria-live', 'polite');
      prayer.closest('label').append(prayerText);
      const updatePrayer = () => {
        const entry = config.prayers[prayer.value]; pronoun.required = Boolean(entry?.needs_pronoun);
        pronoun.closest('label').hidden = !pronoun.required; if (!pronoun.required) pronoun.value = '';
        let text = entry?.text || '';
        if (pronoun.value) text = text.replaceAll('him/her', pronoun.value === 'he' ? 'him' : 'her').replaceAll('his/her', pronoun.value === 'he' ? 'his' : 'her').replaceAll('he/she', pronoun.value);
        prayerText.textContent = text;
      };
      prayer.addEventListener('change', updatePrayer); pronoun.addEventListener('change', updatePrayer); updatePrayer();
      const birth = fields.querySelector('[name="properties[Birth Date]"]'), death = fields.querySelector('[name="properties[Death Date]"]');
      if (birth && death) {
        const dates = () => birth.setCustomValidity(birth.value && death.value && birth.value > death.value ? 'Birth date must precede death date.' : '');
        birth.addEventListener('change', dates); death.addEventListener('change', dates);
      }
    }
    render(config.sections.default ? 'default' : '');
    const validate = event => {
      syncVariant(true);
      if (!form.reportValidity() || variantField.disabled || !variantField.value) { event.preventDefault(); event.stopImmediatePropagation(); }
    };
    form.addEventListener('submit', validate, true);
    form.addEventListener('click', event => { if (event.target.closest('[name="add"]')) validate(event); }, true);
  }
  document.querySelectorAll('[data-rt-card-options]').forEach(init);
})();
